module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Five.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-8"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Chapter Five")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_vm._v("Wedged between Carter and Holden on the bench seat of Rock’s truck, Liv stared out the window as she mindlessly fidgeted with the seam of her jeans. Outside, the world was alive with commuters rushing to work, school or whatever morning appointment they had to get to. Inside the cab, the silence was broken by the hum of the wheels and the occasional shifting of one of the occupants.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The forced inactivity had allowed the numbness to return and suck the thoughts from her mind. It was good in some ways. Not thinking. Floating, detached from the last six hours. From the hours, days, weeks ahead that would inevitably be filled with more pain and recovery. Hopefully there would be recovery for everyone. No matter how long it took.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It should wash out,” Carter said, startling her. She stared at his profile, not following before he glanced to her hand. She tracked his gaze to where she picked at the hardened patch of material on the inside of her knee near the seam. “Put some stain remover on it when you get home.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She jerked her hand back when understanding came. Unconsciously, she’d been scratching at a spot of dried blood. A stain she hadn’t noticed, but her fingers had sought out the different texture and were attempting to scratch it out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry,” she whispered, fisting her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Holden reached over to cover it, much like Noah had done earlier. The hard calluses along Holden’s palm were different from the other man’s. Toughened where Noah’s had been softer, and his hand was warm, no cold fingers. And why was she noticing that?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How are you holding up?” Holden squeezed her hand, and she clung to the offered strength while giving back some of her own.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“As good as I can,” she answered truthfully. “I think that’s what we’re all doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carter grunted an agreement. “This whole thing blows.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fucking sucks,” Holden agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Liv cracked a soft smile and huffed out her own agreement. “The worst.” One second. That was all it’d taken to alter all their lives. “And we have to be there for them,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All of them,” Carter said, nodding in slow agreement before he wiped a hand over his jaw. The sun cut a harsh light across his chin and his eyes were shielded behind sunglasses, but they couldn’t hide the weariness that lined his mouth. “No matter what happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The open-ended statement didn’t need to be finished. There was still so much that could go wrong. So much unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you have to work today, Liv?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked at Holden. “No. Shelly’s going to cover for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He frowned. “What about your numbers?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The adult-to-kid ratios increased with each age group, but she hated to push the limits when most of the children who used the center needed that adult guidance. The fact that he knew that had her throat working to keep the tears at bay.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I called in some favors to fill Shelly’s spot, so they’ll be fine.” She gripped his hand tighter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Have you spoken to the police yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked back to Carter, blinking when the sun blinded her. It seemed wrong for it to be shining so brightly when she felt so dark. “Briefly. At the accident. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They slowed for a stoplight at the end of an exit ramp, and she surveyed the familiar landmarks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carter shrugged, glancing her way before refocusing on the road. “They’ll want to talk to you again. Did Noah say anything about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No.” Her brows drew together, the questions already forming and realigning in her mind. “But I assumed they would.” She closed her eyes against the visions that rushed forward. A swift shake of her head chased them away before she refocused on the passing strip mall.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Holden leaned forward to peer around Liv. “Was Marcus still there when you ran in for the keys?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah.” Carter spared another quick glance away from the road, lips pinched as he looked at Holden. “Rock wanted him to go home, but he refused.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?” Liv swiveled her head between the two men. “What aren’t you saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Holden leaned back to stare out his side window, his hand coming off hers to rub at his shoulder. “Nothing,” he said, still avoiding her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why would Rock want him to leave?” She drilled Carter with a questioning glare that he blatantly ignored. “Is everything okay with Quinn and Blake?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They’re fine,” he answered, his voice communicating his own weariness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The urge to push the point was squelched by Carter pulling into Vanessa’s driveway. Despite the gratitude and friendship that had built over the last months, they didn’t have to tell her anything and they definitely didn’t need her butting into their business.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good luck tonight,” Carter said after he shifted the truck into Park.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Right,” Holden scoffed, head sagging. He pushed the door open, and the brisk air rushed in to contradict the appearance of warmth the sun had provided. He turned around to lean back into the cab, eyes full of concern. “Make sure V eats, would you?” She nodded. He blew out a breath, the white fog billowing away. “And take care of yourself, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re going to her place next.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Liv whipped around to face Carter. “Why? I’m fine.” They didn’t have time to fuss with her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nodded to her jeans. “You need a shower and change of clothes just like the rest of us. If we’re going to take care of them, we have to take care of ourselves first.” His calm insistence overrode her objection.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Carter’s right,” Holden said. He gave her a hug that was comforting but brief and included a platonic kiss to her temple before he stepped away. “We have to be there for them, even if they think they can do it alone.” He winked, a hint of a smirk pulling on the old scar on his chin. “We know better.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carter’s low chuckle filled the cab. “Too true.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Holden closed the door and made his way up the curved path edged with the last of the fall flowers before he bounded onto the porch and let himself into the house. She scooted over in the seat and fastened the seat belt as Carter backed the truck out of the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t suppose there’s a point in trying to change your mind, is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nope.” He shifted into Drive but left the truck idling in the middle of the street. “So you should give me your address if you want to get back to the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She narrowed her eyes, a thousand comebacks shuffling through her mind. The man might be more relaxed and open than his partner, but it appeared he could be just as bullheaded as Rock if he wanted to be.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She let out a sigh and begrudgingly gave him directions to her apartment. The guys were right, but it didn’t stop the frustration from simmering under her skin. It was better to focus on that than to give in to the fear that ate at her stomach and clouded the edges of her thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Action was better. "), _c('em', [_vm._v("Stay busy")]), _vm._v(", "), _c('em', [_vm._v("don’t think.")]), _vm._v(" She’d be fine if she focused on everyone else.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("“What in the hell is going on between you and Liv?” Vanessa stalked toward Noah, every step in her spiked heels a note of contention.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Noah kept his features flat against the anger that rolled out of her. Logically he realized that most of her affront was fueled by fatigue and worry that had nothing to do with Liv. Still, it irritated him. “Nothing is going on,” he said, voice even.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She scanned him, her disdain communicating her disbelief. “I trusted you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The implied note that she couldn’t trust him when he’d done nothing wrong pushed him forward a step and lowered his tone. “I’ve done nothing to break that trust. If anything, I’ve earned it more.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The anger smoldering in his blood merged with the frustration he’d been battling for hours. He didn’t deserve this attack, just like none of them deserved what had happened to them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Really?” She crossed her arms, the challenge raised. “How do you figure that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“V.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Deklan’s deep voice broke through the room, but Noah ignored it. For once, he didn’t give a damn if his emotions showed. Hell, he wanted her to see them. “Who do you think worried about her all night? Who ensured she was okay after what we witnessed? Who—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s enough.” Deklan’s sharp command was low but not weak. He stepped between them, his own anger etched in the hard set of his mouth. “This is bullshit, and you both know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Noah’s anger drained away with the sight of his friend. The one who had a right to be mad. Deklan swayed, and Noah reached out to stabilize him. “Sit.” He motioned to the chairs and ignored the man’s glare, along with his attempt to brush off Noah’s help.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t coddle me,” Deklan grumbled, but he did lower himself into a seat and cradled his head in his palm. “And don’t fight over stupid shit. Not now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Guilt nailed Noah between the eyes with a shot of pain. Damn it. He pressed on the spot between his brows, flinched then forced himself to straighten.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vanessa met his gaze, the apology in her eyes. Whatever issues they might have were irrelevant at the moment. An empty water bottle gave him an excuse to swipe it up and head to the garbage can across the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry,” Vanessa said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Noah turned back to see her sitting next to Deklan, her arm wrapped around his shoulders. The fact that Deklan was accepting the comfort said so much.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He took a moment to gather his composure. He had to keep his head straight, not fly off the handle over something as stupid as his intentions over Liv. Like he had any. Really. He hadn’t had any intentions toward anyone since the last woman he’d loved had committed suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fuck.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The second stab of guilt nailed him right in the heart. Four years later, and it still held him bound to solitude. He rubbed his chest to ease the ache. His personal shit didn’t belong here, not when there was a messed-up present to deal with.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He sent a text to Rock to find out what the detectives had said. It’d been an hour since Rock had texted to say they’d arrived at the other hospital. He stiffened every time the waiting room door opened, expecting to see them here.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His phone buzzed. "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("They’re")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("heading")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("your")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("way")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Great. "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Anything")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("should")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("know")]), _vm._v("? Like was the driver of the suicide truck really Harcourt?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("confirmation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So the question remained if he should share Rock’s deduction with the others. Was it worth adding to the stress if it wasn’t true?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Marcus")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("is")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("driving")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Seth")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Allie")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("over")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("soon")]), _vm._v(". "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("I’m")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("waiting")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("on")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cali")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Nothing")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("new")]), _vm._v(" "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("here")]), _c('em', [_vm._v(".")]), _vm._v(" His update to Rock had been the same for the last three hours. In some ways it was easier, allowing them to still function on hope.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He tucked his phone into his pocket, took one more deep breath and went back to the other two. The room had filled with the morning influx of people waiting for those who had prescheduled operations. Another reminder that the world moved on even though theirs had come to a halt.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He took a seat across from Deklan and Vanessa, uncertainty weighing him down. Another emotion he wasn’t used to. The distant call of the PA system beyond the closed room blended with the low murmur of the ongoing news program.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His gaze shifted to Vanessa, who was studying him with a familiar scrutiny. As a PR rep and a Domme, part of her job was to pick up on what someone wasn’t saying. She’d grilled every one of them with that same look at some point since they’d gone into business together.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you mean? I’ve shared everything I heard from the doctors.” He could play her game. He did it every damn day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sure you have.” The smoothness of her response didn’t relax him at all. “But there’s something else you’re not telling us. You’re too tense. Your control is faltering and you’re watching the door too much.” She lifted her brow in a dare for him to deny her. “So what is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wanted to be annoyed that she’d read him that easily. Instead, he was amused. Was there really a point in trying to avoid them?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This might be more than a simple accident. Wait—” he held his hand up to Deklan, who’d started to push to a stand, “—let me explain.” He narrowed his eyes and stayed quiet until the other man settled back in the chair, the plastic squeaking with its now-annoying sound beneath him. “I’m not one to give out false information or start rumors—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We know,” Deklan interrupted, his words clipped. “Just get to the point.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Noah inhaled, pressing his lips tight. Patience wasn’t something he usually had to search for. “Fine.” The word came out sharper than he’d intended, but neither of them reacted. “Rock warned that the driver of the truck looked a lot like Harcourt.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mother f—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were going to keep this from us?” Vanessa sat forward, her wide eyes exclaiming her disbelief.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There’s no confirmation.” He looked to each of them. “The wreck left everything pretty...mangled.” Not exactly the right word, but it was accurate. “I couldn’t do more than glance at the cab of the truck and confirm there was only one passenger. Rock did the initial check for life before the paramedics arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vanessa shoved a hand through her hair, jaw tight. “If it was him, the chances of that being an accident are about a million to one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That lowlife, stupid-ass...” Deklan snapped his mouth shut. His grip on the armrest turned his knuckles white. Noah had no idea how the man was even sitting there with them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We have to be prepared for the worst,” Vanessa said, all business. “If the media gets ahold of this—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know,” Noah cut in. “I’ve been running scenarios in my head all night.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’d you come up with?” Deklan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A lot.” Too much probably, but it’d kept his mind busy. He held Vanessa’s gaze. “The first thing is to shield who we can from the fallout.” She nodded, but it was slow in coming. “That means Marcus and you need to stay away.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was shaking her head before he finished. “No way. I’m not leaving you guys hanging. I know how to manage the media.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And what about Holden? His career? The club link will come out, and how long do you think it’ll take to connect the dots between you, him and the purpose of the club?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her nostrils flared, but she didn’t argue his point before she looked away. Society as a whole wasn’t tolerant of the BDSM community or understanding of why people sought what it offered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The partnership was set up so only the names of the original owners are on record.” Noah waited for a response but got none.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The media had kept personal names out of the attacks last year when the then city-councilman Remington Harcourt had gone after the sex industry, targeting BDSM clubs specifically. It had been a personal vendetta disguised as a political move to get back at The Den for banishing him from the club and spreading the word that he abused subs. The irony of Harcourt being a well-known Dom within the BDSM community had killed his political career when a videotape showing Harcourt in action had found its way into the greedy hands of a local news station.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why would he do this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vanessa’s question was mumbled, more of a thought spoken out loud. Noah answered anyway. “I’ve been running that through my head all night and can only come up with one answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They both looked at him, but Deklan spoke first. “Revenge.” The most basic motive for so many violent acts. His soft curse mirrored Noah’s feelings on the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vanessa shook her head in a slow motion of disbelief. “I can’t get my head around it. How could anyone do something so destructive out of revenge? I mean, I get that some people are pure evil, but this...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Again, all thoughts he’d already had. “We don’t know for certain that it was him. But,” he paused until he had their attention again. “We should act like it is until we know differently. That means you should go home before the police get here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes,” he fired right back. “As of now, you have zero connection to the accident or the people in it, and it needs to stay that way. We get it. We know you want to be here, but you can’t be.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her head was shaking again, the line of her jaw sharp with the tight hold of her rejection.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I agree with Noah,” Deklan said before she could voice her objection. “You and Marcus have others to think about.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But what about you guys?” She flailed a hand at him. “You can’t expect us to just walk away and pretend we don’t know any of you. That we don’t care.” She swung her focus to Noah. “And what about the club? Someone has to be there, too. If you take Marcus and me out of the equation, that leaves you and Rock with everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not necessarily.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, Deklan.” She glared at him. “You, Jake and Seth have more important things to worry about right now. That isn’t meant in a bad way—it’s just another stinking reality of the situation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve been thinking about that,” Noah said before Deklan could respond. “We can close for a few days, and then there are others who can step up. Rock and I can meet with the employees. There are things you and Marcus can do, but you shouldn’t be seen near the club.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Or here,” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Or here.” He didn’t like it either, but there was really no other option. “Write up a few press statements. Give us pointers on what to say to the employees. Draft up a letter to go out to the BDSM community. We’ll need all of those. Marcus will know the staff situation. He can guide us remotely.” With Quinn being an actress and their having a new baby to protect, Marcus should take them on an extended vacation where the media wouldn’t find them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s not going to like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Probably not,” Noah agreed. “But his options are limited. Like yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about you?” Deklan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll be fine,” Noah assured him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How do you figure?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve spent the last ten years building up my law practice and over fifteen in the local BDSM community. Where do you think I acquire the majority of my clients?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Deklan gave a low grunt. “Okay. But if things turn bad, you need to bail.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m the club’s lawyer. It’s part of my job to defend the business against slander and to protect its assets. That includes all of you.” He shook his head, his conviction as firm as his voice. “I won’t be bailing on anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But you expect Marcus and me to do just that,” Vanessa countered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Protecting your partners isn’t bailing.” Noah held her gaze until she closed her eyes and turned away. “I know you’ll both help however you can.” He understood her resistance, even sympathized. Yet there was no changing the hard facts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The door swung open from the surgery area, and all the attention in the room went to the women in blue scrubs. There was a collective inhale before she said, “The Sturgeon family?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A ripple of expelled breath seemed to expand through the room as an older woman stood, two people who looked like her children flanking her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Noah tracked their progress to the doctor, the brief second of tense expectation draining from his shoulders. The up-and-down rise of hope and letdown had been repeated multiple times since they’d arrived, and each one left him a little more weary.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was tempted to lean his head against the back of the seat and close his eyes, but there was no chance of his resting. He rubbed his palms together and forced himself to pick up their discussion. “Rock said the police were on their way here.” He stared at Vanessa, hating that he had to push this.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The controlled assurance that made her a hell of a Domme came out in full force. “I am not leaving until we know how everyone is. I’m not moving on that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d expected no less. He’d be exactly the same way. “Then you should sit across the room so they don’t know you’re with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why? What does it matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It shouldn’t.” He gave that to her. “But do you want to take the chance? Make the detectives do their jobs. I don’t want to give them anything before we must. Your being here is one of those things.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What did Marcus do then?” She shifted forward, eyes dark with her intensity. “If the police were already over there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rock convinced him to take a walk.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sunk back, defeat settling hard on her features. She shoved her hair away from her face, which only made her scowl seem fiercer. “I don’t like this. None of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He could only nod in understanding. There was nothing to like.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Deklan shifted, cradling the arm in the sling. The pain etched on his face had sagged with the grief and fear that settled deeper the longer they waited.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did they give you any pain meds?” Noah asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Deklan grunted, motioning toward his head. “Not with the head wound. The whole concussion thing...” There was no point in arguing that he shouldn’t even be there.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The door to the surgical area swooshed open at the same time that two men in suits pushed through the door from the hallway. The tension in the room twisted tight in the second it took everyone to eye both doorways.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was no doubt in Noah’s mind that the men in suits were the police detectives they’d been expecting, but it was the doctor who held his attention. His heart rate increased in the short time it took the lean man to tug his surgical mask away from his mouth. He glanced at the clipboard in his hand, then looked up to take in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mr. Bakker?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Noah’s heart dropped to his twisting stomach as he bolted to his feet, Deklan and Vanessa right behind him. The detectives were forgotten, along with the other concerns that hung over him as he headed toward the news that could change everything.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }), _c('p', {
    staticClass: "Basic-Paragraph-6"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c519fba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterFive.vue
// module id = 84
// module chunks = 0